import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react'
import { useForm } from '../../../shared/hooks/Form';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { Button } from 'primereact/button';
import moment from 'moment';
import { InvoiceDiscountList } from '../../../service/invoice/InvoiceDiscountList';
import { get } from 'http';
import { ToastService } from '../../../AppToast';

type Props = {
  invoiceListDiscount: any;
  setInvoiceListDiscount: (value: any) => void;
  invoices: any[];
  display: boolean;
  setInvoices: (value: any[]) => void;
  setDisplay: (value: boolean) => void;
  setDisplaySelectInvoiceDiscounted: (value: boolean) => void;
  setDisplayCrup: (value: boolean) => void;
  selectedItems: any;
  setSelectedItems: (value: any) => void;
  setRelatedInvoiceProperty: (value: any) => void;
  setSelectedInvoice: (value: any) => void;
  handleUpdate: (value: any) => void;
  invoiceSerial?: string;
}

const DialogDiscountInvoiceAttachment = ({ invoiceListDiscount, setInvoiceListDiscount, invoices, display, setInvoices, setDisplay, setDisplaySelectInvoiceDiscounted, setDisplayCrup, selectedItems, setSelectedItems, setRelatedInvoiceProperty, setSelectedInvoice, handleUpdate, invoiceSerial }: Props) => {
  const [selected, setSelected] = useState(null);

  const { render: renderForm, setValue, getValue, valid } = useForm({
    fields: [
      { field: 'invoiceListNumber', disabled: true, header: 'Số bảng kê', className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'sellerTaxCode', header: 'Mã số thuế bên bán', className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', required: true },
      { field: 'buyerTaxCode', header: 'Mã số thuế bên mua', className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', required: true },
      { field: 'invoiceListDate', header: 'Ngày bảng kê', className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', type: 'Calendar' },
      { field: 'sellerLegalName', header: 'Tên đơn vị bán', className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', required: true },
      { field: 'buyerLegalName', header: 'Tên khách hàng', className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', required: true },
      { field: 'note', type: 'InputTextarea', header: 'Ghi chú', className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'sellerAddress', type: 'InputTextarea', header: 'Địa chỉ bên bán', className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', required: true },
      { field: 'buyerAddress', type: 'InputTextarea', header: 'Địa chỉ người mua', className: 'md:col-4', labelClassName: 'md:col-4', inputClassName: 'md:col-8', required: true },
    ],
    layout: 'Horizontal'
  });

  const handleClose = () => {
    setSelectedItems(null)
    setSelectedInvoice(null)
    setDisplay(false)
    setInvoiceListDiscount(null)
    setValue({
      sellerTaxCode: null,
      buyerTaxCode: null,
      sellerLegalName: null,
      buyerLegalName: null,
      sellerAddress: null,
      buyerAddress: null,
    })
    setInvoices([])
  }

  useEffect(() => {
    if (invoiceListDiscount) {
      setValue({
        invoiceListNumber: invoiceListDiscount.invoiceListNumber,
        ...invoiceListDiscount
      })
      setInvoices(invoiceListDiscount.invoiceDiscountListItems)
      return
    }

    if (invoices[0]) {
      setValue({
        ...getValue(),
        sellerTaxCode: invoices[0]?.sellerTaxCode,
        buyerTaxCode: invoices[0]?.buyerTaxCode,
        sellerLegalName: invoices[0]?.sellerLegalName,
        buyerLegalName: invoices[0]?.buyerLegalName,
        sellerAddress: invoices[0]?.sellerAddress,
        buyerAddress: invoices[0]?.buyerAddress,
        invoiceNumber: invoices[0]?.invoiceNumber,
        invoiceSerial: invoices[0]?.invoiceSerial,
      })
      return
    }

    setValue({
      invoiceListDate: new Date(),
    })

  }, [invoices[0], invoiceListDiscount, display])

  // useEffect(() => {
  //   setValue({
  //     invoiceListDate: new Date(),
  //   })
  // }, [display])

  return (
    <Dialog
      header="Bảng kê đính kèm hóa đơn chiết khấu"
      visible={display} position="top"
      style={{ width: '100vw' }}
      onHide={handleClose}
      footer={() => <>
        {![2, 3, 4].includes(selectedItems?.sendTaxStatus) ? (
          <>
            <Button
              // icon="pi pi-plus"
              label="Đóng"
              className="p-button-outlined mr-4"
              onClick={handleClose}
            />
            <Button
              icon="pi pi-plus"
              label="Lưu và xuất hóa đơn chiết khấu"
              className="p-button-outlined mr-4"
              onClick={() => {
                if (!valid()) {
                  return ToastService.error('Vui lòng nhập đầy đủ thông tin');
                }
                if (invoiceListDiscount) {
                  InvoiceDiscountList.update(invoiceListDiscount.id, {
                    ...getValue(),
                    invoiceDiscountListItems: invoices.map(invoice => ({ ...invoice, invoiceCode: invoice.invoiceSerial })),
                  }).then((item) => {
                    setInvoiceListDiscount(null)
                    handleUpdate({ ...invoiceListDiscount, ...selectedItems, relatedInvoiceProperty: 5 })
                    setDisplay(false)
                    setInvoices([])
                  })
                  return
                }
                InvoiceDiscountList.create({
                  ...getValue(),
                  invoiceSerial,
                  invoiceDiscountListItems: invoices.map(invoice => ({ ...invoice, invoiceCode: invoice.invoiceSerial })),
                }).then((item) => {
                  setSelectedItems({
                    ...item,
                    // invoiceDetail: [{_id: `added-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}`}],
                    relatedInvoiceProperty: 5
                  })
                  setDisplayCrup(true)
                  setDisplay(false)
                  // setInvoiceStatus(2)
                  setRelatedInvoiceProperty(5)
                  setInvoices([])
                })
              }}
            />
          </>
        ) : (
          <>
            <Button
              label="Đóng"
              className="p-button-outlined mr-4"
              onClick={handleClose}
            />
          </>
        )}
      </>}
    >
      {renderForm()}
      <p className="font-bold text-xl mt-4">Danh sách hóa đơn được chiết khấu theo doanh số</p>
      {![2, 3, 4].includes(selectedItems?.sendTaxStatus) && (
        <div className="flex align-items-center gap-4" >
          <Button icon="pi pi-plus" label="Thêm hóa đơn" className="p-button-outlined" onClick={() => setDisplaySelectInvoiceDiscounted(true)} />
          <Button
            icon="pi pi-trash"
            label="Xóa dòng HĐ"
            className="p-button-outlined p-button-danger"
            onClick={() => {
              const selectedIds = selected.map(product => product.id);
              const updatedInvoices = invoices.filter(invoice => !selectedIds.includes(invoice.id));
              setInvoices(updatedInvoices);
              setSelected(null);
            }}
          />
          <i>(Vui lòng ấn "Thêm hóa đơn" để lấy Danh sách hóa đơn lên Bảng kê hóa đơn chiết khấu)</i>
        </div>
      )}
      {/* <span>(Vui lòng ấn "Thêm hóa đơn" để lấy Danh sách hóa đơn lên Bảng kê hóa đơn chiết khấu)</span> */}
      <DataTable
        value={invoices}
        tableStyle={{ width: '100%' }}
        showGridlines
        selectionMode={null}
        selection={selected}
        onSelectionChange={(e) => setSelected(e.value)}
        dataKey="id"
        footerColumnGroup={
          <ColumnGroup>
            <Row>
              <Column colSpan={7} footer="Tổng tiền" />
              <Column
                colSpan={1}
                align='right'
                footer={new Intl.NumberFormat('vi-VN').format(invoices.reduce((sum, num) => sum + num.totalAmountWithoutVAT, 0))}
              />
              <Column
                colSpan={1}
                align='right'
                footer={new Intl.NumberFormat('vi-VN').format(invoices.reduce((sum, num) => sum + num.vatAmount, 0))} />
              <Column
                colSpan={1}
                align='right'
                footer={new Intl.NumberFormat('vi-VN').format(invoices.reduce((sum, num) => sum + num.totalAmount, 0))} />
              <Column colSpan={1} />
            </Row>
          </ColumnGroup>
        }
        className='mt-4'
      >
        <Column selectionMode="multiple" style={{ width: '50px' }} align='center'></Column>
        <Column field="" header="STT" body={((data, options) => options.rowIndex + 1)} style={{ width: '50px' }} align='center'></Column>
        <Column field="invoiceSerial" header="Ký hiệu" style={{ width: '100px' }} align='center'></Column>
        <Column field="invoiceNumber" header="Số hóa đơn" style={{ width: '100px' }} align='center'></Column>
        <Column field="invoiceDate" header="Ngày hóa đơn" style={{ width: '150px' }} align='center' body={(data, options) => moment(data).format('DD/MM/YYYY')}></Column>
        <Column field="currencyCode" header="Đơn vị tiền tệ" style={{ width: '120px' }} align='center'></Column>
        <Column field="exchangeRate" header="Tỷ giá" style={{ width: '80px' }} align='center'></Column>
        <Column
          field="totalAmountWithoutVAT"
          header="Tổng tiền trước thuế"
          align='right'
          alignHeader='center'
          body={(data, options) =>
            new Intl.NumberFormat('vi-VN').format(data.totalAmountWithoutVAT)
          }
        />
        <Column
          field="vatAmount"
          header="Tổng tiền thuế"
          align='right'
          alignHeader='center'
          body={(data, options) => new Intl.NumberFormat('vi-VN').format(data.vatAmount)}
        />
        <Column
          field="totalAmount"
          header="Tổng tiền thanh toán"
          align='right'
          alignHeader='center'
          body={(data, options) => new Intl.NumberFormat('vi-VN').format(data.totalAmount)}
        />
        <Column
          field="taxAuthorityCode"
          header="Mã CQT" align='center'></Column>
      </DataTable>
    </Dialog>
  )
}

export default DialogDiscountInvoiceAttachment